import React from 'react'
import AntTag from 'antd/lib/tag'
import type { TagProps as AntTagProps, TagType } from 'antd/lib/tag'
import { registerComponentProperty, getColor } from '../util/util'
import { useMemo } from 'react'
import useSplitArray from '../hooks/useSplitArray'
import Popover from '../popover'
import classnames from 'classnames'

export interface TagProps extends AntTagProps {
  tags?: string | string[]
  flat?: number
}

const Tag = ({ tags, flat = 4, ...props }: TagProps) => {
  const tagsArray = useMemo(() => {
    if (Array.isArray(tags)) {
      return tags
    }
    return tags?.split(',').map((tag: string) => tag.trim()) || []
  }, [tags])

  const color = useMemo(() => {
    return props.color === 'primary' ? undefined : getColor(props.color) || props.color
  }, [props.color])

  const [flattenTags, popoverTags] = useSplitArray(tagsArray, flat)

  const renderTags = (tags: string[]) => {
    return tags
      .filter(_ => !!_)
      .map(tag => (
        <Tag {...props} key={tag} title={tag}>
          {tag}
        </Tag>
      ))
  }

  return flattenTags.length ? (
    <div className="flex flex-wrap gap-y-2 gap-x-1">
      {renderTags(flattenTags)}
      {!!popoverTags.length && (
        <Popover
          placement="top"
          content={<div className="flex flex-wrap gap-y-2 gap-x-1">{renderTags(popoverTags)}</div>}
        >
          <Tag {...props}>+ {popoverTags.length}</Tag>
        </Popover>
      )}
    </div>
  ) : (
    <AntTag
      {...props}
      color={color}
      className={classnames({
        [props.className!]: !!props.className,
      })}
    />
  )
}

export default registerComponentProperty<typeof Tag, typeof AntTag>(Tag, AntTag)

export { TagType }
